import React from "react";

const ImageVolumeFull = (props) => {
	return (
		<svg
			className="icon-volume-full unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				transform="translate(2 4)"
				className="image-fill-color"
				style={{ fill: props.fillOverride }}
				d="M4.075 4l5.911-4v16l-5.748-4H0V4h4.075zM12 4.21c1.892.378 3.315 2.025 3.315 4s-1.423 3.622-3.315 4v-1.69a2.453 2.453 0 0 0 1.658-2.31A2.453 2.453 0 0 0 12 5.9V4.21zM12 0c4.188.403 7.46 3.831 7.46 8 0 4.169-3.272 7.597-7.46 8v-1.618c3.27-.396 5.802-3.102 5.802-6.382S15.27 2.014 12 1.618V0z"
			/>
		</svg>
	);
};

export default ImageVolumeFull;
